const downloadBlobFile = (data, fileName) => {
  let blob = new Blob([data], { type: 'application/pdf' })
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    window.navigator.msSaveBlob(blob, fileName)
  } else {
    let link = document.createElement('a')
    link.style = 'display: none'
    let url = window.URL.createObjectURL(blob)
    link.target = '_blank'
    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    setTimeout(function () {
      window.URL.revokeObjectURL(url)
      document.body.removeChild(link)
    }, 100)
  }
}

export default downloadBlobFile
